<template lang="pug">
.selector(:class="parameter")
  .selection
    .selection__inner
      template(v-if="selection")
        img.product-image(:src="selection.image")
        p.product-name {{ selection.name }}
      .base-image(v-else)
        .connector
          .base
          .body
          .input
  SelectionError(:visible="error", :text="errorText")

  SelectionAction(
    @open="open = true",
    @close="open = false",
    :actionText="actionText",
    :open="open",
    :error="error",
    :selected="!!selection",
    :products="connectors",
    :parameter="parameter"
  )
</template>

<script>
import SelectionAction from "./SelectionAction";
import SelectionError from "./SelectionError";
import { mapGetters } from "vuex";
export default {
  name: "SelectorConnector",
  props: ["parameter"],
  components: {
    SelectionAction,
    SelectionError,
  },
  data() {
    return {
      open: false,
      error: false,
      errorText: "",
    };
  },
  computed: {
    ...mapGetters(["connectors", "model", "validity", "touched", "productLookup"]),
    selection() {
      const sku = this.model[this.parameter];
      if (sku) {
        return this.connectors.find((c) => c.sku === sku);
      }
      return false;
    },
    actionText() {
      return `${
        this.selection
          ? '<i class="glyph-pencil"></i><span>Edit'
          : '<i class="glyph-add"></i><span>Choose'
      } Connector ${this.parameter === "connector_left" ? "A" : "B"}</span>`;
    },
  },
  methods: {
    isDisabledInChildren() {
      if (!this.selection || !this.model.cable) return false;
      const connector = this.productLookup(this.selection.sku);
      if (!connector || !Array.isArray(connector.children)) return false;
      return connector.children.some(
        (child) =>
          child.category === "cable" &&
          Array.isArray(child.meta && child.meta.compatibility) &&
          child.meta.compatibility.includes(this.model.cable) &&
          child.disabled === true
      );
    },
    handleError() {
      let error = false;
      let errorText = "";
      if (this.isDisabledInChildren()) {
        error = true;
        errorText = "The desired configuration is out of stock.";
      } else if (this.selection && this.selection.disabled === true) {
        error = true;
        errorText = "The selected product is not currently available.";
      } else if (this.touched) {
        if (!this.selection) {
          error = true;
          errorText = "Please select a connector.";
        } else if (!this.validity(this.selection)) {
          error = true;
          errorText =
            "This connector is not compatible with your cable selection.";
        }
      } else {
        if (this.selection && !this.validity(this.selection)) {
          error = true;
          errorText =
            "This connector is not compatible with your cable selection.";
        }
      }
      this.error = error;
      this.errorText = errorText;
    },
  },
  watch: {
    touched() {
      this.handleError();
    },
    model: {
      deep: true,
      handler() {
        this.handleError();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.selector {
  // display: flex;
  // flex-direction: column;
  // grid-area: span 1 / span 1;
}

.selection {
  border: 1px solid $midGray;
  overflow: hidden;
  position: relative;
  &::before {
    position: relative;
    display: block;
    content: "";
    padding-top: 100%;
    @include mq(md) {
      padding-top: 80%;
    }
  }

  &__inner {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
  }
}

.product {
  &-image {
    padding: clamp(0.75rem, 3vw, 1.5rem);
    object-fit: scale-down;
    flex: 1 1 100%;
    margin-bottom: auto;
    margin: 0 auto;
    @include mq(md) {
      max-width: 200px;
    }
  }

  &-name {
    margin-top: auto;
    border-top: 1px solid lighten($midGray, 7%);
    flex: 0 0 auto;
    margin: 0;
    text-align: center;
    padding: 1rem 1.25rem;
    font-size: 0.75rem;
    @include mqdn(lg) {
      @include hideVisually;
    }
  }
}

.base-image {
  margin: auto;
  z-index: 0;
  position: relative;
  min-width: 2.75rem;
  width: 33.333%;
  max-width: 8rem;
  .connector_left & {
    transform: rotate(180deg);
  }
  .selected & {
    display: none;
  }
  &::before {
    position: relative;
    display: block;
    content: "";
    padding-top: 87.5%;
  }

  .connector {
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    &::before {
      content: "";
      height: 20%;
      background: $black;
      width: 50vw;
      position: absolute;
      right: 100%;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .base {
    height: 60%;
    width: 20%;
    background: $black;
    border-right: 1px solid lighten($black, 10%);
    z-index: 2;
  }

  .body {
    height: 100%;
    width: 60%;
    background: $black;
    left: -1px;
    clip-path: polygon(
      0 10%,
      7.5% 0,
      92.5% 0,
      100% 10%,
      100% 90%,
      92.5% 100%,
      7.5% 100%,
      0 90%
    );
    border: none;
    position: relative;
    z-index: 1;
    &::before,
    &::after {
      content: "";
      position: absolute;
      top: 33.333%;
      background: lighten($black, 10%);
      height: 1px;
      width: 100%;
    }
    &::after {
      top: 66.666%;
    }
  }

  .input {
    position: relative;
    height: 80%;
    width: 20%;
    background: $black;
    border-left: 1px solid lighten($black, 10%);
    border-radius: 0 0.25rem 0.25rem 0;
    z-index: 2;
    left: -2px;
  }
}
</style>